import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOReservationDialogHeaderView extends React.Component {
  constructor(props) {
    super(props);
    this.hideDialog = this.hideDialog.bind(this);
  }

  hideDialog() {
    const $dialog = $("#js-split_view-dialog");
    $dialog.find("> *").
      off("mousedown").
      off("touchstart");
    $dialog.fadeOut(function(){
      ReactDOM.unmountComponentAtNode($dialog.get(0));
    });
    if (SMAppHelper.isMobile()) SMAppHelper.canBodyScroll(true);
  }

  render() {
    if (SMAppHelper.isMobile()) {
      return (
        <div className="js-maincol-lightbox__close">
          <a href="#" onClick={this.hideDialog.bind(this)}><i className="fa fa-times"></i></a>
        </div>
      );
    }
    return null;
  }
}
export default SMOReservationDialogHeaderView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationDialogHeaderView.jsx